<template>
  <div :id="containerId" style="width: 100%;height: 100%;background-color: black"></div>
</template>

<script>
import util from "@/util/util";

export default {
  name: "trkShow",
  props: {
    fileName: String,
    containerId: String
  },
  data() {
    return {}
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      var r = new window.X.renderer3D();
      r.container = this.containerId;
      r.init();
      console.log(r)
      r.camera.position = [0, 400, 0];
      var fibers = new window.X.fibers();
      fibers.file = util.baseUrl + this.fileName;
      console.log(fibers)
      var skull = new window.X.mesh();
      skull.file =  util.baseUrl + "BrainMesh_Ch2.obj"
      skull.opacity = 0.5;
      r.add(skull)
      r.add(fibers)
      r.onRender = function () {
      };
      r.render();
    }
  }
}
</script>

<style scoped>

</style>